import { render } from "./MainPageHero.vue?vue&type=template&id=5a8cf505"
import script from "./MainPageHero.vue?vue&type=script&lang=js"
export * from "./MainPageHero.vue?vue&type=script&lang=js"

import "./MainPageHero.vue?vue&type=style&index=0&id=5a8cf505&lang=scss"

import exportComponent from "/opt/render/project/src/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__